/**
 * Service API pour le panier
 */

import { api, ApiResponse } from '../services/api';
import { Cart, AddToCartInput, UpdateCartItemInput } from '../types/cart';

interface CartResponse {
  cart: Cart;
}

export const cartApi = {
  /**
   * Recuperer le panier de l'utilisateur
   */
  async getCart(): Promise<ApiResponse<CartResponse>> {
    return api.get<CartResponse>('/api/cart');
  },

  /**
   * Ajouter un article au panier
   */
  async addToCart(data: AddToCartInput): Promise<ApiResponse<CartResponse>> {
    return api.post<CartResponse>('/api/cart/items', data);
  },

  /**
   * Mettre a jour la quantite d'un article dans le panier
   */
  async updateCartItem(data: UpdateCartItemInput): Promise<ApiResponse<CartResponse>> {
    return api.put<CartResponse>(`/api/cart/items/${data.articleId}`, {
      quantity: data.quantity,
    });
  },

  /**
   * Retirer un article du panier
   */
  async removeFromCart(articleId: string): Promise<ApiResponse<CartResponse>> {
    return api.delete<CartResponse>(`/api/cart/items/${articleId}`);
  },

  /**
   * Vider le panier
   */
  async clearCart(): Promise<ApiResponse<CartResponse>> {
    return api.delete<CartResponse>('/api/cart');
  },
};
